import { render, staticRenderFns } from "./MpService.vue?vue&type=template&id=92759030&scoped=true&"
import script from "./MpService.vue?vue&type=script&lang=js&"
export * from "./MpService.vue?vue&type=script&lang=js&"
import style0 from "./MpService.vue?vue&type=style&index=0&id=92759030&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92759030",
  null
  
)

export default component.exports